import { render, staticRenderFns } from "./confetti.vue?vue&type=template&id=71c3010e&"
import script from "./confetti.vue?vue&type=script&lang=js&"
export * from "./confetti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports